import { render, staticRenderFns } from "./BulkUploadContainer.vue?vue&type=template&id=235af190&"
import script from "./BulkUploadContainer.vue?vue&type=script&lang=js&"
export * from "./BulkUploadContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports